import React from 'react';
import { AuthorBlogCard } from '../../../Author/AuthorBlogCard';
import { BlogRelatedProduct } from '../../../../types/pages/blog';

interface RelatedBlogsProps {
  relatedBlogs: BlogRelatedProduct[];
}

export default function RelatedBlogs({ relatedBlogs }: RelatedBlogsProps) {
  return (
    <div className="w-full bg-grayFA mb-4 md:mb-10 lg:mb-16">
      <div className="w-[90%] md:w-[85%] lg:w-[88%] xl:w-[85%] 2xl:w-[80%] 3xl:w-[74%] 4xl:w-[74%] mx-auto flex flex-col gap-10 py-12">
        <h2 className="text-black2 text-xl sm:text-[22px] md:text-[26px] 2xl:text-3xl font-semibold tracking-[0.4px]">
          Related Blogs
        </h2>
        {relatedBlogs?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:gap-[30px] thin-scrollbar overflow-auto max-h-[900px]">
            {relatedBlogs.map((blog: any) => (
              <AuthorBlogCard
                key={blog.id}
                blog={blog}
                authorName={blog.authorName}
                authorImage={blog.authorImage}
              />
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 my-8">
            <h2 className="text-xl font-semibold">No Blogs Found</h2>
            <p className="mt-2">
              It seems there are no blogs available for this category at the
              moment. Please check back later for updates!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
